function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useEffect, useState } from 'react';
import FocusTrap from 'focus-trap-react';
import { LoginForm } from 'swag-client-common/components/login-form';
import ControlDialog from 'swag-client-common/components/info/control-dialog';
import classes from './login-popup.scss';
let interval;
const focusTrapOptions = {
  escapeDeactivates: true,
  clickOutsideDeactivates: true,
  checkCanFocusTrap: trapContainers => {
    const results = trapContainers.map(trapContainer => {
      return new Promise(resolve => {
        interval = setInterval(() => {
          if (getComputedStyle(trapContainer).visibility !== 'hidden') {
            resolve();
            clearInterval(interval);
          }
        }, 120);
      });
    });
    return Promise.all(results);
  }
};
const TrapChild = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  let {
      isOpen,
      onClose
    } = _ref,
    params = _objectWithoutProperties(_ref, ["isOpen", "onClose"]);
  return /*#__PURE__*/React.createElement(ControlDialog, {
    open: isOpen,
    onRequestClose: onClose,
    content: /*#__PURE__*/React.createElement(LoginForm, params),
    dialogClass: classes.popup,
    bodyClassName: classes.bodyClassName,
    contentClassName: classes.contentClassName,
    actionsContainerClassName: classes.actionsContainerClassName,
    paperClassName: classes.paperClassName,
    closeButtonClassName: params.isLimitedEdition ? classes.orangeClose : '',
    dataPopup: "Login",
    focusTrapRef: ref
  });
});
TrapChild.displayName = 'TrapChild';
const LoginPopup = _ref2 => {
  let {
      isOpen,
      onClose
    } = _ref2,
    params = _objectWithoutProperties(_ref2, ["isOpen", "onClose"]);
  const [isTrapActive, setIsTrapActive] = useState(false);
  useEffect(() => {
    if (isOpen) {
      setIsTrapActive(true);
    }
    return () => {
      clearInterval(interval);
    };
  }, [isOpen]);
  return /*#__PURE__*/React.createElement(FocusTrap, {
    active: isTrapActive
    // @ts-ignore TODO: fix in SWAG-20943
    ,
    focusTrapOptions: focusTrapOptions
  }, /*#__PURE__*/React.createElement(TrapChild, _extends({
    isOpen: isOpen,
    onClose: onClose
  }, params)));
};
export { LoginPopup };